"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import SectionContainer from "@/components/common/SectionContainer";
export default function Glamping() {
  const {
    ref: word1Ref,
    isVisible: word1Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word2Ref,
    isVisible: word2Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word3Ref,
    isVisible: word3Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3501" id="glamping-cta-button" className="relative bg-background text-foreground overflow-hidden py-24 md:py-40 lg:py-[200px]">
      {}
      <div className="hidden md:block absolute left-6 top-1/2 -translate-y-1/2 z-10">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] block" style={{
        color: "var(--primary)",
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          CTA — ESCAPE
        </span>
      </div>

      {}
      <div className="hidden md:block absolute right-0 top-0 bottom-0 w-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 8px var(--primary)"
    }} aria-hidden="true" />

      {}
      <div className="md:hidden absolute left-0 right-0 top-0 h-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 4px var(--primary)"
    }} aria-hidden="true" />

      <SectionContainer className="relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-7 lg:col-start-1">
            <h2 className="font-default font-extrabold uppercase leading-[0.9] text-foreground text-[56px] sm:text-[80px] md:text-[110px] lg:text-[140px]" style={{
            letterSpacing: "-0.04em"
          }}>
              <span ref={word1Ref} data-index={0} className="block transition-all duration-700 ease-out" style={{
              opacity: word1Visible ? 1 : 0,
              transform: word1Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "0ms"
            }}>
                RESERVE /
              </span>
              <span ref={word2Ref} data-index={1} className="block transition-all duration-700 ease-out" style={{
              opacity: word2Visible ? 1 : 0,
              transform: word2Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "200ms"
            }}>
                YOUR /
              </span>
              <span ref={word3Ref} data-index={2} className="block transition-all duration-700 ease-out" style={{
              opacity: word3Visible ? 1 : 0,
              transform: word3Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "400ms"
            }}>
                WILDERNESS
                <span className="inline-block align-baseline" style={{
                color: "var(--primary)",
                fontSize: "1.3em",
                lineHeight: 0
              }}>
                  .
                </span>
              </span>
            </h2>
          </div>

          {}
          <div className="lg:col-span-5 lg:col-start-8 flex lg:justify-end">
            <div ref={cardRef} className="w-full lg:max-w-[440px] p-8 md:p-10 border border-foreground/10 backdrop-blur-sm transition-all duration-700 ease-out shadow-lg" style={{
            backgroundColor: "hsla(0, 0%, 100%, 0.04)",
            opacity: cardVisible ? 1 : 0,
            transform: cardVisible ? "translateX(0)" : "translateX(40px)",
            transitionDelay: "600ms"
          }}>
              {}
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] mb-6" style={{
              color: "var(--primary)"
            }}>
                LUXURY GLAMPING
              </div>

              {}
              <p className="font-default font-light text-base md:text-lg leading-relaxed text-foreground/90 mb-8">
                Experience the perfect harmony of rugged nature and refined comfort. Secure your private sanctuary under the stars today.
              </p>

              {}
              

              {}
              <div className="mt-5 font-mono text-[11px] uppercase tracking-[0.18em]" style={{
              color: "var(--muted-foreground)"
            }}>
                SEASONAL AVAILABILITY — BOOK NOW
              </div>
            </div>
          </div>
        </div>
      </SectionContainer>
    </section>;
}